import React from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Link,
  Divider,
} from '@mui/material';
import { Facebook, Instagram, YouTube, LinkedIn } from '@mui/icons-material';
import AppBarComponent from '../newTestPrepDesign/component/AppBar';

function ContactUsPage() {
    const sectionTitleStyle = {
        fontWeight: 'bold',
        color: '#228B22',
        fontSize: "16px",
        mt: 3,
  };
  return (
    <>
      <AppBarComponent />
      <Container maxWidth="md" sx={{ mt: 12, py: 5 }}>
        <Typography variant="h2" gutterBottom>
          Contact Us
        </Typography>
        <Typography paragraph>
          Have questions? Need guidance with your test preparation or course selection? We’re here to help!
          Get in touch with the <strong>STM</strong> (SIEC Test Masters) team through the details below — whether you're a student,
          parent, or professional, our support team is happy to assist you.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom >
          📍 Head Office Address
        </Typography>
        <Typography>
          STM (SIEC Test Masters)<br />
          A1/153, Ground Floor,<br />
          Behind Green Fields School,<br />
          Safdarjung Enclave,<br />
          New Delhi – 110029, India
        </Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom>
          📞 Phone
        </Typography>
        <Typography>
          Reach us directly at: <strong>+91-9779046382</strong><br />
          (Monday to Saturday, 10:00 AM – 6:00 PM IST)
        </Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom >
          📧 Email Support
        </Typography>
        <Typography>
          General Enquiries: <a href="mailto:cscanada@siecindia.com">cscanada@siecindia.com</a><br />
          Refund or Payment Queries: <a href="mailto:cscanada@siecindia.com">cscanada@siecindia.com</a><br />
          <i>We typically respond within 24–48 working hours.</i>
        </Typography>

        <Typography variant="h6" sx={sectionTitleStyle} gutterBottom >
          🕐 Office Hours
        </Typography>
        <Typography>
          Monday to Saturday: 10:00 AM – 6:00 PM<br />
          Sunday: <strong>Closed</strong>
        </Typography>

        <Typography variant="h5" sx={sectionTitleStyle} gutterBottom>
          🌐 Follow Us on Social Media
        </Typography>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item>
            <Link href="#" target="_blank" rel="noopener noreferrer">
              <Facebook fontSize="large" />
            </Link>
          </Grid>
          <Grid item>
            <Link href="#" target="_blank" rel="noopener noreferrer">
              <Instagram fontSize="large" />
            </Link>
          </Grid>
          <Grid item>
            <Link href="#" target="_blank" rel="noopener noreferrer">
              <YouTube fontSize="large" />
            </Link>
          </Grid>
          <Grid item>
            <Link href="#" target="_blank" rel="noopener noreferrer">
              <LinkedIn fontSize="large" />
            </Link>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4 }} />

        <Typography variant="h6" sx={sectionTitleStyle}>
          👩‍🏫 Already a Student?
        </Typography>
        <Typography>
          Log in to your personalized dashboard here: <br />
          👉 <a href="https://student.siectestmasters.in" target="_blank" rel="noopener noreferrer">
            https://student.siectestmasters.in
          </a>
        </Typography>
      </Container>
    </>
  );
}

export default ContactUsPage;
